module.exports = __webpack_public_path__ + "static/media/toefl.a302d96b.png";